import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';
import TooltipWrapper from 'js/components/global/TooltipWrapper';
import { Select } from 'react-nice-inputs';
import moment from 'moment';

class RoomAvailabilityTooltip extends PureComponent {
  state = {
    isTooltipOpen: true,
    validDate: false,
  };

  _isMobile = window.innerWidth < 768;

  _generateOptions() {
    let options = [];
    const { startDate } = this.props;
    const endDate = startDate.clone();
    const disabledDays = this.props.disabledDays;
    const maxDate = moment('01-01-2028', 'MM-DD-YYYY', true);
    const daysDiff = maxDate.diff(endDate, 'days');
    let limitNights = 21;

    limitNights = daysDiff >= 21 ? 21 : daysDiff;

    while (disabledDays.indexOf(endDate.format('YYYY-MM-DD')) === -1) {
      if (options.length >= limitNights) {
        break;
      }
      const endDateLabel = endDate.add(1, 'days').format('MMMM DD YYYY');
      const nightLabel = `${options.length + 1} ${
        options.length + 1 > 1 ? 'Nights' : 'Night'
      }`;

      options.push({
        value: options.length + 1,
        label: `${endDateLabel} - ${nightLabel}`,
      });
    }

    if (options.length < 3) {
      options = [];
    }

    const fixedOptions = options.filter((option) => option.value > 2);

    return fixedOptions;
  }

  onChange = (value, name) => {
    /**
     * This condition is only to make sure that the number of days selected only
     * changes if one of the users chooses a correct option in the dropdown of the calendar.
     */
    if (value) {
      this.setState({validDate: true});
      this.props.onChange(value, name, this.props.startDate);
    } else {
      this.setState({validDate: false});
    }
  };

  applyNewDates = () => {
    this.props.applyNewDates();
  };

  _content() {
    // const { value } = this.props;
    const options = this._generateOptions();
    const valid = this.state.validDate;

    return (
      <div className="worst-ux-tooltip">
        <label className="pick-date" htmlFor="dropdownEndDate">
          Available Check-Out Date:
        </label>
        <Select
          name="dropdownEndDate"
          classList={['']}
          onChange={this.onChange}
          options={options}
          value={null}
          // value={value}
          // noDefault
        />

        {this._isMobile && !this.props.isRoomDetails && (
          <button className={`apply-new-dates-btn ${valid ? '' : 'disabled'}`} onClick={this.applyNewDates}>
            Apply New Dates
          </button>
        )}
      </div>
    );
  }

  onTooltipChange = ({ isVisible }) => {
    this.setState({
      isTooltipOpen: isVisible,
    });
  };

  render() {
    return (
      <TooltipWrapper
        content={this._content()}
        onChange={this.onTooltipChange}
        children={this.props.children}
        withCloseButton={false}
        isVisible={this.props.isVisible}
      />
    );
  }
}

RoomAvailabilityTooltip.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  startDate: momentPropTypes.momentObj.isRequired,
};

RoomAvailabilityTooltip.defaultProps = {
  value: 0,
  onChange() {},
  startDate: moment(),
};

export default RoomAvailabilityTooltip;



// WEBPACK FOOTER //
// ./js/components/step2/room/RoomAvailabilityTooltip.js